import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { GenerateDescriptionRequest } from './generate-description.interface';
import { GenerateDescriptionService } from './generate-description.service';
const service = new GenerateDescriptionService();

export interface GenerateDescriptionState {}

const GenerateDescriptionStore: Module<GenerateDescriptionState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postGenerateDescription(context, descriptionData: GenerateDescriptionRequest) {
         const response = await service.postGenerateDescription(descriptionData);
         return response;
      },
   },
};

export default GenerateDescriptionStore;
